import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { Project } from '../project';

@JsonObject('model.activity.ActivityType')
export class ActivityType extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'group')
    group?: string;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'title')
    title?: string;

    @JsonProperty(String, 'shortCode')
    shortCode?: string;

    @JsonProperty(Number, 'pos')
    pos: number;

    @JsonProperty(Number, 'level')
    level: number;

    @JsonProperty(String, 'color')
    color?: string;

    @JsonProperty(Boolean, 'enabled')
    enabled?: boolean;

    @JsonProperty(Boolean, 'major')
    major?: boolean;
}